import { Button } from '../../components';
import React from 'react';
import { RolesManagementService } from '../../services';
import warning from '../../assets/svg/warning.svg';
import  '../Modal/Modal.global.scss';

interface Props {
  handleModalClose: any;
  id: any;
  fetchDomesList: any;
  setShowOverlay: any;
  status: any;
}
const RoleManagementBlocked: React.FC<Props> = (props: Props) => {
  const {
    handleModalClose,
    id,
    fetchDomesList,
    setShowOverlay,
    status,
  } = props;

  const [blocked, setBlocked] = React.useState(false);
  const blockService = () => {
    setShowOverlay(true);
    RolesManagementService.blockedRole({ roleId: id, status }).then(() => {
      setBlocked(true);
      setShowOverlay(false);
    });
  };

  return (
    <>
      {!blocked ? (
        <>
          <img src={warning} alt="warning" />
          <h2>
            {status === 'blocked' ? 'Block' : 'Unblock'}
            {' '}
            Role
          </h2>
          <p>
            Are you sure you want to
            {' '}
            {status === 'blocked' ? 'block' : 'unblock'}
            {' '}
            this Role?
          </p>
          <div className="modalButtonWrapper">
            <Button onClick={handleModalClose}>No</Button>
            <Button intent={status === 'blocked' ? 'danger' : 'primary'} onClick={blockService}>Yes</Button>
          </div>
        </>
      ) : (
        <>
          <h3>
            Role
            {' '}
            {status === 'blocked' ? 'blocked' : 'unblocked'}
            {' '}
            successfully !
          </h3>
          <Button onClick={() => {
            handleModalClose();
            fetchDomesList({
              page: 1,
              rowsPerPage: 10,
            });
          }}
          >
            Ok
          </Button>
        </>
      )}

    </>
  );
};

export default RoleManagementBlocked;
